import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import ReactRouterPropTypes from 'react-router-prop-types';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { formatDate, toQueryParams } from 'admin/utils';
import {
  getSoftwares,
  getSoftwareProductCodes,
  getSoftwareTargetHardwares,
  deleteSoftware,
} from 'admin/actions/softwares';
import LabeledSelect from 'admin/components/molecules/LabeledSelect';
import _Select, { addNullOption } from 'admin/components/atoms/Select';
import Breadcrumb from 'admin/components/shared/Breadcrumb';
import Button from 'admin/components/shared/Button';
import TableHeader from 'admin/components/shared/TableHeaders';
import TableRows from 'admin/components/shared/TableRows';
import Pager from 'admin/components/shared/Pager';
import { openAlertModal } from 'admin/actions/alert-modal';

const LabelText = styled.span`
  font-weight: 600;
`;

const FilterBox = styled.div`
  ${LabeledSelect} {
    display: block;
    margin: 15px;
    float: left;
  }
  ${_Select} {
    margin-left: 15px;
    width: 200px;
  }
  button {
    margin: 15px;
    float: right;
  }
`;

const Hr = styled.hr`
  clear: both;
  border-bottom: 1px solid #CCC;
`;

const ListTable = styled.div`
  padding: 20px;
`;

const ButtonsContainer = styled.div`
  float: right;
  button {
    margin-left: 10px;
  }
`;

const NoResultText = styled.span`
  font-weight: 600;
  font-size: 20px;
  padding: 10px;
  text-align: center;
  display: block;
`;

const unselect = { label: 'すべて', value: null };

class Softwares extends Component {

  constructor(props) {
    super(props);
    this.defaultPagination = { page: 1, per_page: 20 };
    this.state = {
      selectedProductCode: unselect,
      selectedTargetHardware: unselect,
      currentPage: 1,
    };
  }

  componentWillMount() {
    this.props.getSoftwareProductCodes();
    this.refreshSoftwares(this.state);
  }

  componentWillUpdate(nextProps, nextState) {
    if (this.state.selectedProductCode !== nextState.selectedProductCode ||
        this.state.selectedTargetHardware !== nextState.selectedTargetHardware) {
      if (this.state.selectedProductCode !== nextState.selectedProductCode) {
        if (nextState.selectedProductCode.value) {
          this.props.getSoftwareTargetHardwares(nextState.selectedProductCode.value);
          this.setState({
            selectedTargetHardware: unselect,
          });
        }
      }
      this.refreshSoftwares(nextState);
    }
  }

  refreshSoftwares = (state) => {
    const params = Object.assign({}, this.defaultPagination, {
      productCode: state.selectedProductCode.value,
      targetHardware: state.selectedTargetHardware.value,
      page: state.currentPage,
    });
    this.props.getSoftwares(toQueryParams(params, true));
  }

  onChangeProductCode = (op) => {
    this.setState({
      selectedProductCode: op,
    });
  }

  onChangeTargetHardware = (op) => {
    this.setState({
      selectedTargetHardware: op,
    });
  }

  onClickedDelete = (id, version) => {
    this.props.openAlertModal({
      body: `ビルド ${version} を削除します。この動作は取り消しできません。よろしいですか？`,
      useCancel: true,
      confirmText: '削除する',
      confirmColor: 'danger',
      onConfirm: () => {
        this.props.deleteSoftware(id).then(() => {
          this.refreshSoftwares(this.state);
        });
      },
    });
  }

  onChangePage = (page) => {
    this.setState({
      currentPage: page,
    }, () => this.refreshSoftwares(this.state));
  }

  render() {
    const crumb = [
      { value: 'ホーム', href: '/', active: false },
      { value: 'サービス管理', href: '', active: true },
      { value: 'ソフトウェアビルド管理', href: '/service-settings/software', active: true },
    ];
    const columns = [
      { label: 'プロダクト', align: 'center', size: 0.5 },
      { label: 'ハードウェア', align: 'center', size: 0.5 },
      { label: 'バージョンコード', align: 'center', size: 1 },
      { label: '登録日時', align: 'center', size: 1 },
      { label: '', align: 'center', size: 1 },
    ];
    const rows = this.props.softwares.rows.map(row => [
      { data: (<span>{row.product_code}</span>), align: 'center' },
      { data: (<span>{row.target_hardware}</span>), align: 'center' },
      { data: (<strong>{row.version_code}</strong>), align: 'center' },
      { data: (<span>{formatDate(row.created_at)}</span>), align: 'center' },
      {
        data: (
          <ButtonsContainer>
            <a href={row.url}>
              <Button color="gray">
                URLを開く
              </Button>
            </a>
            <Button onClick={() => this.onClickedDelete(row.id, row.version_code)} color="danger">
              削除
            </Button>
          </ButtonsContainer>
        ),
      },
    ]);
    return (
      <div>
        <Breadcrumb items={crumb} />
        <FilterBox>
          <LabeledSelect
            labelText={(<LabelText>プロダクト</LabelText>)}
            options={
            addNullOption(this.props.softwareProductCodes.map(m => ({
              label: m,
              value: m,
            })), 'すべて')
            }
            value={this.state.selectedProductCode}
            onChange={this.onChangeProductCode}
          />
          <LabeledSelect
            labelText={(<LabelText>ハードウェア</LabelText>)}
            options={
            addNullOption(this.props.softwareTargetHardwares.map(m => ({
              label: m,
              value: m,
            })), 'すべて')
            }
            value={this.state.selectedTargetHardware}
            onChange={this.onChangeTargetHardware}
          />
          <Link to="/service-settings/software/create">
            <Button color="gray">
              新しいビルドを手動登録
            </Button>
          </Link>
        </FilterBox>
        <Hr />
        {
          (!rows || rows.length === 0) ? (
            <NoResultText>結果がありません</NoResultText>
          ) : (
            <div>
              <ListTable>
                <TableHeader columns={columns} />
                <TableRows rows={rows} columns={columns} />
              </ListTable>
              <Pager
                pagination={this.props.softwares.pagination}
                onChangePage={this.onChangePage}
              />
            </div>
          )
        }
      </div>
    );
  }
}

Softwares.defaultProps = {
  softwares: { rows: [], count: 0, pagination: { current: 1, per_page: 30 } },
  softwareProductCodes: [],
  softwareTargetHardwares: [],
};

const mapStateToProps = state => ({
  softwares: state.software.softwares,
  softwareProductCodes: state.software.softwareProductCodes,
  softwareTargetHardwares: state.software.softwareTargetHardwares,
});

Softwares.propTypes = {
  openAlertModal: PropTypes.func.isRequired,
  getSoftwares: PropTypes.func.isRequired,
  getSoftwareProductCodes: PropTypes.func.isRequired,
  getSoftwareTargetHardwares: PropTypes.func.isRequired,
  deleteSoftware: PropTypes.func.isRequired,
  softwareProductCodes: PropTypes.arrayOf(PropTypes.string),
  softwareTargetHardwares: PropTypes.arrayOf(PropTypes.string),
  softwares: PropTypes.shape({
    rows: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number,
      product_code: PropTypes.string,
      target_hardware: PropTypes.string,
      version_code: PropTypes.string,
      url: PropTypes.string,
      created_at: PropTypes.string,
      updated_at: PropTypes.string,
    })),
    count: PropTypes.number,
    pagination: PropTypes.shape({
      current: PropTypes.number,
      per_page: PropTypes.number,
    }),
  }),
  match: PropTypes.shape({
    params: PropTypes.object,
  }).isRequired,
  history: ReactRouterPropTypes.history.isRequired,
};

const mapDispatchToProps = dispatch => bindActionCreators({
  getSoftwares,
  getSoftwareProductCodes,
  getSoftwareTargetHardwares,
  deleteSoftware,
  openAlertModal,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Softwares);
